import React from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../utils/api';
import toast from 'react-hot-toast';
import './ProfileCard.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function getTypeBadgeClass(type) {
  if (!type) return '';
  if (type === 'Sutham') return 'badge-sutham';
  if (type === 'Seva') return 'badge-seva';
  if (type === 'Rahu Ketu') return 'badge-rahuketu';
  return 'badge-sevarahu';
}

export default function ProfileCard({ profile, onShortlistToggle }) {
  const navigate = useNavigate();
  const matchScore = profile.matchScore || 0;
  const matchColor = profile.matchColor || 'red';
  const isShortlisted = !!profile.is_shortlisted;

  const handleShortlist = async (e) => {
    e.stopPropagation();
    try {
      const { data } = await API.post('/api/shortlist/toggle', { profile_id: profile.user_id });
      toast.success(data.message);
      if (onShortlistToggle) onShortlistToggle(profile.user_id, data.action === 'added');
    } catch {
      toast.error('Failed to update shortlist');
    }
  };

  const handleContact = async (e) => {
    e.stopPropagation();
    try {
      await API.post('/api/contacts/request', { receiver_id: profile.user_id });
      toast.success('Contact request sent!');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to send request');
    }
  };

  return (
    <div className="profile-card" onClick={() => navigate(`/profile/${profile.user_id}`)}>
      {/* Photo */}
      <div className="pc-photo-wrap">
        {profile.photo_path ? (
          <img src={`${API_URL}${profile.photo_path}`} alt={profile.full_name} className="pc-photo" />
        ) : (
          <div className="pc-photo-placeholder">
            <span>{profile.profile_type === 'bride' ? '👰' : '🤵'}</span>
          </div>
        )}
        {/* Match Score */}
        {matchScore > 0 && (
          <div className={`pc-match-badge ${matchColor}`}>
            {matchScore}%
          </div>
        )}
        {/* Verified */}
        <div className="pc-verified-badge">✓ Verified</div>
      </div>

      {/* Info */}
      <div className="pc-info">
        <div className="pc-top-row">
          <h3 className="pc-name">{profile.full_name}</h3>
          <span className={`badge ${getTypeBadgeClass(profile.horoscope_type)}`}>
            {profile.horoscope_type}
          </span>
        </div>

        <div className="pc-details">
          <span>🎂 {profile.age} yrs</span>
          {profile.height && <span>📏 {profile.height}</span>}
          {profile.native_place && <span>📍 {profile.native_place}</span>}
        </div>

        {profile.education && <p className="pc-edu">🎓 {profile.education}</p>}
        {profile.job_profession && <p className="pc-job">💼 {profile.job_profession}</p>}

        <div className="pc-horoscope-row">
          {profile.birth_star && <span className="pc-tag">⭐ {profile.birth_star}</span>}
          {profile.rasi && <span className="pc-tag">♈ {profile.rasi}</span>}
        </div>

        {/* Match Label */}
        {profile.matchLabel && (
          <div className={`pc-match-label ${matchColor}`}>
            {'★'.repeat(profile.matchStars || 1)}{'☆'.repeat(5 - (profile.matchStars || 1))} {profile.matchLabel}
          </div>
        )}

        {/* Actions */}
        <div className="pc-actions">
          <button className="btn btn-primary btn-sm" onClick={(e) => { e.stopPropagation(); navigate(`/profile/${profile.user_id}`); }}>
            View Profile
          </button>
          <button
            className={`btn btn-sm ${isShortlisted ? 'btn-shortlisted' : 'btn-outline'}`}
            onClick={handleShortlist}
            title={isShortlisted ? 'Remove from shortlist' : 'Add to shortlist'}
          >
            {isShortlisted ? '❤️' : '🤍'}
          </button>
          {profile.contact_status !== 'approved' && profile.contact_status !== 'pending' && (
            <button className="btn btn-outline btn-sm" onClick={handleContact}>
              📞 Request
            </button>
          )}
          {profile.contact_status === 'pending' && (
            <span className="pc-req-sent">⏳ Requested</span>
          )}
        </div>
      </div>
    </div>
  );
}
